import React, { Component } from 'react';
import { Container } from 'reactstrap';

class Paragraph extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Container className="mb-5 mt-5 paragraph-module" dangerouslySetInnerHTML={{ __html: this.props.text }} />
    );
  }
}

export default Paragraph;